<template>
    <div v-show="list.length!=0" class="aside-1">
        <dl>
            <div class="title"><i></i>{{title}}</div>
        </dl>
        <dd v-for="(item,index) in list"><i></i>
            <a  :href="item.open_type==0?`/news/${item.id}`:item.third_url" >{{item.title}}</a><span>{{friendlyTime(item.released_at)}}</span></dd>
        <span></span>
    </div>
</template>
<script>
    import friendlyTime from 'asset/js/utils/friendlyTime';
import Vue from 'vue';
import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload, {
  error: '/public/w/img/wap/loading.png',
  loading: '/public/w/img/wap/loading.png',
});
    export default {
        props: ['title', 'list'],
        data() {
            return {
                friendlyTime
            }
        },
        components: {}
    };
</script>


// WEBPACK FOOTER //
// app/web/component/web/news-aside/index.vue